import RoleList from 'src/features/roles/RoleList';
import { ClaimType } from '../../features/common/RenderIf';

const RoleListScreen = () => {
    return <RoleList />
}

RoleListScreen.guestGuard = false;
RoleListScreen.authGuard = true;
RoleListScreen.claimType = ClaimType.Roles;

export { RoleListScreen }
export default RoleListScreen;